module.exports = __webpack_public_path__ + "static/media/CuramLife.a7477a8b.svg";